//@ts-check
import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import { getRTCExpirationDate } from '../../modules/clients/utils/index';
import ScorecardProgressBar from '../ScorecardProgressBar';

const ClientConnectsProgressBar = ({ classes, completed, goal, title, isAssociateDetails, userBrand }) => {
  const percentDisplay = completed > 0 ? (100 * completed) / goal : 0;
  const expiryDate = getRTCExpirationDate();

  return (
    <>
      <Box className={classes.contentContainer}>
        <Typography variant="h3" color="textPrimary" className={classes.caption}>
          {title}
        </Typography>
        <Typography
          variant="h3"
          color="textPrimary"
          className={!isAssociateDetails ? classes.value : classes.associateValue}
        >
          {!isAssociateDetails ? `${percentDisplay.toFixed(0)}%` : `${Number(completed)}/${Number(goal)}`}
        </Typography>
      </Box>
      <ScorecardProgressBar netSales={completed} goal={goal} displayMPS={false} userBrand={userBrand} />

      <Box>
        <Typography
          className={classes.salesThrough}
          variant="body2"
          color="textSecondary"
          data-testid="client-connects-expiry-date"
        >
          Client Connects expiring {expiryDate}
        </Typography>
      </Box>
    </>
  );
};

ClientConnectsProgressBar.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  completed: PropTypes.number,
  goal: PropTypes.number,
  title: PropTypes.string,
  isAssociateDetails: PropTypes.bool,
  userBrand: PropTypes.string,
};

ClientConnectsProgressBar.defaultProps = {
  classes: {},
  completed: 0,
  goal: 0,
  title: 'Overall Progress',
  isAssociateDetails: false,
  userBrand: '',
};

export default ClientConnectsProgressBar;
